import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmHousesIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmHousesIcon = ({ className, ...props }: EmHousesIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.25658 7.14655V5.32124L7.10876 5.32983V4.20577L8.52673 4.19717V5.30405H8.38064V6.37655L7.25658 7.14655Z"
      fill="#DE7541"
    />
    <path
      d="M10.9759 5.12875L7.38892 8.56969L7.55735 12.7978L14.8191 12.7497L14.7434 8.27407L10.9759 5.12875Z"
      fill="#FFF3E1"
    />
    <path
      d="M7.25134 12.8288L7.60025 12.6191V8.48892L7.27541 8.72439C7.27541 8.72439 7.3115 12.8288 7.25134 12.8288Z"
      fill="#5F4E47"
    />
    <path
      d="M14.4719 8.63843V12.6534L14.8569 12.87V8.78796L14.4719 8.63843Z"
      fill="#5F4E47"
    />
    <path
      d="M11.0636 5.36594L7.27723 8.92031L7.25488 7.95609L11.1221 4.29172L14.8604 8.16234L14.8569 9.02172L11.0636 5.36594Z"
      fill="#BDA890"
    />
    <path
      d="M6.89047 7.78593L6.68079 8.34452L7.26516 8.3514C7.26516 8.3514 11.0017 4.69562 11.0825 4.69218C11.1805 4.68874 14.8569 8.33421 14.8569 8.33421L15.3794 8.33765L11.3145 3.91359L10.7233 3.87405L6.89047 7.78593Z"
      fill="#904625"
    />
    <path
      d="M6.1772 8.06608C6.06376 8.17436 6.12907 8.33077 6.2322 8.33936C6.33876 8.34796 6.84235 8.34624 6.84235 8.34624L10.9089 4.23499C10.9089 4.23499 11.0034 4.13874 11.0705 4.14217C11.1427 4.14561 11.2372 4.23671 11.2372 4.23671L15.3433 8.33249C15.3433 8.33249 15.6475 8.33936 15.7438 8.33421C15.9019 8.32389 15.9345 8.14342 15.7558 7.9853C15.675 7.91311 11.5999 3.85858 11.5311 3.78639C11.3283 3.57671 11.2286 3.45467 11.0361 3.46155C10.8436 3.47014 10.7284 3.6128 10.5359 3.78983C10.4758 3.84311 6.20642 8.03686 6.1772 8.06608Z"
      fill="#DC7540"
    />
    <path
      d="M9.77966 12.4592C9.77966 12.4592 9.79513 10.0151 9.80888 9.44624C9.82263 8.87734 10.3572 8.42187 10.9742 8.4064C11.7631 8.38749 12.1326 8.86359 12.1619 9.41874C12.1894 9.9739 12.1894 12.4575 12.1894 12.4575L9.77966 12.4592Z"
      fill="#D27857"
    />
    <path
      d="M11.452 10.7456C11.4468 10.8986 11.5087 11.0223 11.6891 11.0223C11.8696 11.0223 11.9366 10.9381 11.9487 10.7731C11.9607 10.6253 11.8576 10.4964 11.6891 10.5067C11.5207 10.517 11.4571 10.6373 11.452 10.7456Z"
      fill="#FFBA02"
    />
    <path
      d="M10.34 7.69829C10.34 7.69829 10.352 7.04344 10.3589 6.73235C10.3657 6.42126 10.6579 6.17204 10.9965 6.16344C11.4107 6.15313 11.6307 6.41266 11.6462 6.71688C11.6617 7.0211 11.6582 7.69657 11.6582 7.69657L10.34 7.69829Z"
      fill="#A6CFD6"
    />
    <path
      d="M1.91816 12.6552V10.89L1.77722 10.8986V9.81063L3.14878 9.80203V10.8728H3.00613V11.9109L1.91816 12.6552Z"
      fill="#AB5832"
    />
    <path
      d="M5.70275 10.6322L1.88541 14.2965L1.88025 18.614L9.60947 18.5625L9.71259 13.9803L5.70275 10.6322Z"
      fill="#EDE0D6"
    />
    <path
      d="M1.73767 18.8478L2.1158 18.8169L2.11064 14.2072L1.76345 14.4581C1.76345 14.4598 1.73939 18.7877 1.73767 18.8478Z"
      fill="#5F4E47"
    />
    <path
      d="M9.42556 14.367L9.39978 18.6364L9.83462 18.8908V14.5269L9.42556 14.367Z"
      fill="#5F4E47"
    />
    <path
      d="M5.79737 10.8848L1.75831 14.6747L1.75659 13.6262L5.85753 9.74014L9.83815 13.8617L9.83472 14.7761L5.79737 10.8848Z"
      fill="#BCAFAA"
    />
    <path
      d="M1.35439 13.4595L1.30798 14.0628L1.7583 14.0594C1.7583 14.0594 5.73033 10.1698 5.81626 10.1664C5.92111 10.1612 9.8347 14.0559 9.8347 14.0559L10.3624 14.0594L6.06376 9.33968L5.4347 9.29843L1.35439 13.4595Z"
      fill="#7F4935"
    />
    <path
      d="M0.601563 13.762C0.481251 13.8789 0.550001 14.0542 0.658282 14.0594C0.754532 14.0628 1.31313 14.0628 1.31313 14.0628L5.6375 9.68342C5.6375 9.68342 5.73719 9.5803 5.80938 9.58373C5.88672 9.58717 5.98641 9.68514 5.98641 9.68514L10.3486 14.0594C10.3486 14.0594 10.6734 14.0628 10.7817 14.0662C10.9209 14.0714 10.9656 13.8686 10.7766 13.7001C10.6906 13.6228 6.37313 9.28123 6.29922 9.20561C6.08266 8.98217 5.9761 8.85155 5.77156 8.86014C5.56703 8.86873 5.445 9.01998 5.23875 9.20905C5.17859 9.26577 0.632501 13.7311 0.601563 13.762Z"
      fill="#BB8064"
    />
    <path
      d="M4.4292 18.6192C4.4292 18.6192 4.44467 15.8348 4.46014 15.2298C4.47561 14.6248 5.04279 14.1384 5.70107 14.123C6.53982 14.1023 6.93514 14.6094 6.96436 15.2006C6.99357 15.7919 6.99357 18.6175 6.99357 18.6175L4.4292 18.6192Z"
      fill="#865C51"
    />
    <path
      d="M6.20983 16.6117C6.20295 16.775 6.26998 16.9073 6.46248 16.9073C6.65498 16.9073 6.72545 16.8163 6.7392 16.6427C6.75123 16.4863 6.64295 16.347 6.46248 16.3591C6.28201 16.3711 6.21498 16.4966 6.20983 16.6117Z"
      fill="#FFB700"
    />
    <path
      d="M1.73767 18.8495L2.11408 18.5161L9.39814 18.5144L9.8347 18.8925L1.73767 18.8495Z"
      fill="#BEB4AC"
    />
    <path
      d="M5.02734 13.3667C5.02734 13.3667 5.03938 12.6689 5.04797 12.3389C5.05656 12.0089 5.36594 11.7425 5.72687 11.7339C6.16859 11.7236 6.40234 12.0003 6.41781 12.3234C6.435 12.6465 6.43156 13.3667 6.43156 13.3667H5.02734Z"
      fill="#6CA4AE"
    />
    <path
      d="M18.9389 12.6638V10.8986L18.7963 10.9055V9.81751L20.1678 9.81064V10.8814H20.0269V12.7789L18.9389 12.6638Z"
      fill="#AB5832"
    />
    <path
      d="M16.1803 10.6683L12.3629 14.3326L12.6104 18.7722L20.1196 18.8306L20.1918 14.0164L16.1803 10.6683Z"
      fill="#F5E1D1"
    />
    <path
      d="M12.2065 18.9578L12.5881 18.8134V14.245L12.2409 14.4959C12.2409 14.4959 12.2701 18.9578 12.2065 18.9578Z"
      fill="#5F4E47"
    />
    <path
      d="M19.9031 14.4048L19.9048 18.8031L20.3139 19.0042L20.3121 14.563L19.9031 14.4048Z"
      fill="#5F4E47"
    />
    <path
      d="M16.2748 10.9209L12.2426 14.8414L12.234 13.6623L16.3367 9.77625L20.3156 13.8978L20.3121 14.8122L16.2748 10.9209Z"
      fill="#D2A67C"
    />
    <path
      d="M11.8318 13.4956L11.7596 14.08L12.2375 14.0955C12.2375 14.0955 16.2095 10.2059 16.2954 10.2025C16.4003 10.1973 20.3156 14.08 20.3156 14.08L20.8398 14.0834L16.5412 9.37578L15.9121 9.33453L11.8318 13.4956Z"
      fill="#893F2E"
    />
    <path
      d="M11.079 13.7981C10.9742 13.9012 11.0206 14.0611 11.1426 14.0697C11.2097 14.0748 11.7614 14.08 11.7614 14.08L16.115 9.71952C16.115 9.71952 16.2147 9.6164 16.2868 9.61984C16.3642 9.62327 16.4639 9.72124 16.4639 9.72124L20.8398 14.0834C20.8398 14.0834 21.1767 14.0851 21.2575 14.0817C21.4242 14.0748 21.4792 13.9167 21.2747 13.7105C21.1939 13.6297 16.8506 9.31734 16.7784 9.24171C16.5618 9.01827 16.4553 8.88765 16.2507 8.89624C16.0462 8.90484 15.9242 9.05609 15.7179 9.24515C15.6561 9.30187 11.1117 13.7672 11.079 13.7981Z"
      fill="#C67260"
    />
    <path
      d="M14.9084 18.6553C14.9084 18.6553 14.9239 15.8709 14.9394 15.2659C14.9549 14.6609 15.522 14.1745 16.1803 14.1591C17.0191 14.1384 17.4144 14.6455 17.4436 15.2367C17.4728 15.828 17.4728 18.6536 17.4728 18.6536L14.9084 18.6553Z"
      fill="#AB5832"
    />
    <path
      d="M16.6891 16.6478C16.6822 16.8111 16.7492 16.9434 16.9417 16.9434C17.1342 16.9434 17.2047 16.8523 17.2184 16.6787C17.2305 16.5223 17.1222 16.3831 16.9417 16.3951C16.7613 16.4072 16.6925 16.5326 16.6891 16.6478Z"
      fill="#FEB800"
    />
    <path
      d="M12.2152 18.9595L12.5796 18.6244L19.9049 18.6261L20.3122 19.0025L12.2152 18.9595Z"
      fill="#D4A37D"
    />
    <path
      d="M15.5049 13.4028C15.5049 13.4028 15.5169 12.705 15.5255 12.375C15.5341 12.045 15.8435 11.7786 16.2044 11.77C16.6461 11.7597 16.8799 12.0364 16.8954 12.3595C16.9125 12.6826 16.9091 13.4028 16.9091 13.4028H15.5049Z"
      fill="#6CA4AE"
    />
  </svg>
);

export default EmHousesIcon;
